import { render, staticRenderFns } from "./SampleDataChip.vue?vue&type=template&id=4085ded2&"
import script from "./SampleDataChip.vue?vue&type=script&lang=js&"
export * from "./SampleDataChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports